export const GENERIC = 'ST';

export const SPAIN = 'ES';

export const CANARY_ISLANDS = 'IC';

export const PORTUGAL = 'PT';

export const NETHERLAND = 'NL';

export const IRELAND = 'IE';

export const UNITED_KINGDOM = 'GB';

export const SWEDEN = 'SE';

export const NORWAY = 'NO';

export const SWITZERLAND = 'CH';

export const DENMARK = 'DK';

export const POLAND = 'PL';

export const GERMANY = 'DE';

export const AUSTRIA = 'AT';

export const ITALY = 'IT';

export const FRANCE = 'FR';

export const BELGIUM = 'BE';

export const LUXEMBOURG = 'LU';

export const MONACO = 'MC';

export const RUMANIA = 'RO';

export const GREECE = 'GR';

export const RUSSIA = 'RU';

export const MEXICO = 'MX';

export const CANADA = 'CA';

export const USA = 'US';

export const CZECH_REPUBLIC = 'CZ';

export const CHINA = 'CN';

export const KOREA = 'KR';

export const CROATIA = 'HR';

export const SLOVAKIA = 'SK';

export const BULGARIA = 'BG';

export const SLOVENIA = 'SI';

export const FINLAND = 'FI';

export const HUNGARY = 'HU';

export const ESTONIA = 'EE';

export const LITHUANIA = 'LT';

export const LATVIA = 'LV';

export const TURKEY = 'TR';

export const CYPRUS = 'CY';

export const MALTA = 'MT';

export const MA = 'MA';

// NO VENTA
export const HK = 'HK';

export const CR = 'CR';

export const SA = 'SA';

export const AE = 'AE';

export const KW = 'KW';

export const AD = 'AD';

export const BH = 'BH';

export const JO = 'JO';

export const QA = 'QA';

export const EG = 'EG';

export const GT = 'GT';

export const ID = 'ID';

export const KZ = 'KZ';

export const MO = 'MO';

export const MY = 'MY';

export const RS = 'RS';

export const SG = 'SG';

export const SY = 'SY';

export const UA = 'UA';

export const CO = 'CO';

export const TH = 'TH';

export const IL = 'IL';

export const PH = 'PH';

export const GE = 'GE';

export const DO = 'DO';

export const MK = 'MK';

export const PR = 'PR';

export const TW = 'TW';

export const AM = 'AM';

export const PA = 'PA';

export const AZ = 'AZ';

export const HN = 'HN';

export const EC = 'EC';

export const AL = 'AL';

export const BA = 'BA';

export const TN = 'TN';

export const IN = 'IN';

export const LB = 'LB';

export const BY = 'BY';

export const VN = 'VN';

export const XK = 'XK';

export const WW = 'WW';
